import React from 'react';
import Select from './../Select';
import {get, set} from "../../../utils/dotutils";
import isEqual from 'lodash-es/isEqual';
import {sendRequest} from "../../../utils/request";
import TextInput from "../TextInput";
import {CurrencyFormatter} from "../../../utils/formatters";

class ExternalShippingControl extends React.Component {

    setFieldValue = (field, value) => {
        this.props.saveChanges && this.props.saveChanges(field, value);
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        return {
            ...this.props.fields,
            shipping_fee: <TextInput
                    {...this.getProps("shipping_fee")}
                    name="shipping_fee"
                    required={true}
                    label="Ár"
                    formatter={CurrencyFormatter}
                    className="currency"
                    value={this.props.value && this.props.value.shipping_fee}
                    saveChanges={(field, value) => this.setFieldValue(field, value || value + "" === "0" ? value : null)}
                />,
            vat: <Select
                    {...this.getProps("vat")}
                    name="vat"
                    component="vatrate"
                    filter={{field: "active", value: 1}}
                    required={true}
                    objectValue={true}
                    label="Áfa"
                    storeType="local"
                    value={(this.props.value && this.props.value.vat) || null}
                    view={["rate"]}
                    saveChanges={this.setFieldValue}
                />,
        }
    }

    getLayout = () => {
        const fields = this.getFields();
        return <div className="col-md-12">
            <div className="row">
                <div className="col-md-6 currency">
                    {fields.shipping_fee}
                </div>
                <div className="col-md-6">
                    {fields.vat}
                </div>
            </div>
        </div>;
    }

    render() {
        return this.props.layout ? this.props.layout(this.getFields()) : this.getLayout();
    }

}

export default ExternalShippingControl;